/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Game studio API
 * Game studio API documentation OAS.
 * OpenAPI spec version: v1
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  ChangeUserPasswordCommand,
  ResetUserPasswordCommand,
  ResetUserPasswordEmailCommand,
  Unit
} from '../../backoffice-schemas';

import putApiUsersChangePasswordMutator from '../../../lib/customInstance';
import postApiUsersResetTokenMutator from '../../../lib/customInstance';
import postApiUsersResetMutator from '../../../lib/customInstance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const putApiUsersChangePassword = (
    changeUserPasswordCommand: ChangeUserPasswordCommand,
 options?: SecondParameter<typeof putApiUsersChangePasswordMutator>,) => {
      
      
      return putApiUsersChangePasswordMutator<Unit>(
      {url: `https://api.dev.gocore.gg/api/Users/change-password`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: changeUserPasswordCommand
    },
      options);
    }
  


export const getPutApiUsersChangePasswordMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiUsersChangePassword>>, TError,{data: ChangeUserPasswordCommand}, TContext>, request?: SecondParameter<typeof putApiUsersChangePasswordMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof putApiUsersChangePassword>>, TError,{data: ChangeUserPasswordCommand}, TContext> => {

const mutationKey = ['putApiUsersChangePassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiUsersChangePassword>>, {data: ChangeUserPasswordCommand}> = (props) => {
          const {data} = props ?? {};

          return  putApiUsersChangePassword(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiUsersChangePasswordMutationResult = NonNullable<Awaited<ReturnType<typeof putApiUsersChangePassword>>>
    export type PutApiUsersChangePasswordMutationBody = ChangeUserPasswordCommand
    export type PutApiUsersChangePasswordMutationError = unknown

    export const usePutApiUsersChangePassword = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiUsersChangePassword>>, TError,{data: ChangeUserPasswordCommand}, TContext>, request?: SecondParameter<typeof putApiUsersChangePasswordMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiUsersChangePassword>>,
        TError,
        {data: ChangeUserPasswordCommand},
        TContext
      > => {

      const mutationOptions = getPutApiUsersChangePasswordMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const postApiUsersResetToken = (
    resetUserPasswordEmailCommand: ResetUserPasswordEmailCommand,
 options?: SecondParameter<typeof postApiUsersResetTokenMutator>,signal?: AbortSignal
) => {
      
      
      return postApiUsersResetTokenMutator<null>(
      {url: `https://api.dev.gocore.gg/api/Users/reset-token`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: resetUserPasswordEmailCommand, signal
    },
      options);
    }
  


export const getPostApiUsersResetTokenMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUsersResetToken>>, TError,{data: ResetUserPasswordEmailCommand}, TContext>, request?: SecondParameter<typeof postApiUsersResetTokenMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiUsersResetToken>>, TError,{data: ResetUserPasswordEmailCommand}, TContext> => {

const mutationKey = ['postApiUsersResetToken'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiUsersResetToken>>, {data: ResetUserPasswordEmailCommand}> = (props) => {
          const {data} = props ?? {};

          return  postApiUsersResetToken(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiUsersResetTokenMutationResult = NonNullable<Awaited<ReturnType<typeof postApiUsersResetToken>>>
    export type PostApiUsersResetTokenMutationBody = ResetUserPasswordEmailCommand
    export type PostApiUsersResetTokenMutationError = unknown

    export const usePostApiUsersResetToken = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUsersResetToken>>, TError,{data: ResetUserPasswordEmailCommand}, TContext>, request?: SecondParameter<typeof postApiUsersResetTokenMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiUsersResetToken>>,
        TError,
        {data: ResetUserPasswordEmailCommand},
        TContext
      > => {

      const mutationOptions = getPostApiUsersResetTokenMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const postApiUsersReset = (
    resetUserPasswordCommand: ResetUserPasswordCommand,
 options?: SecondParameter<typeof postApiUsersResetMutator>,signal?: AbortSignal
) => {
      
      
      return postApiUsersResetMutator<null>(
      {url: `https://api.dev.gocore.gg/api/Users/reset`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: resetUserPasswordCommand, signal
    },
      options);
    }
  


export const getPostApiUsersResetMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUsersReset>>, TError,{data: ResetUserPasswordCommand}, TContext>, request?: SecondParameter<typeof postApiUsersResetMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiUsersReset>>, TError,{data: ResetUserPasswordCommand}, TContext> => {

const mutationKey = ['postApiUsersReset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiUsersReset>>, {data: ResetUserPasswordCommand}> = (props) => {
          const {data} = props ?? {};

          return  postApiUsersReset(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiUsersResetMutationResult = NonNullable<Awaited<ReturnType<typeof postApiUsersReset>>>
    export type PostApiUsersResetMutationBody = ResetUserPasswordCommand
    export type PostApiUsersResetMutationError = unknown

    export const usePostApiUsersReset = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUsersReset>>, TError,{data: ResetUserPasswordCommand}, TContext>, request?: SecondParameter<typeof postApiUsersResetMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiUsersReset>>,
        TError,
        {data: ResetUserPasswordCommand},
        TContext
      > => {

      const mutationOptions = getPostApiUsersResetMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    